<template>
  <Toolbar class="padding-x">
    <template #left>
      <img v-if="customLogo" :src="customLogo" class="custom-logo cursor-pointer" />
      <img v-else @click="goToLogin" src="@/assets/bridgit.svg" class="header-toolbar cursor-pointer" />
    </template>

    <template #right>
      <div class="header-toolbar flex">
        <img src="@/assets/icons/phone.svg" class="p-mr-2" />
        <!-- <img class="ml-2" src="@/assets/icons/phone-no.svg" alt="" /> -->
        <div class="header-info">
          <p class="phone-info">
            <a :href="`tel:+${phoneInfo.replace(/ /g, '')}`" target="_blank">{{ phoneInfo }}</a>
          </p>
          <!--href="'tel:+1300141161'" -->
          <span class="week-info">Weekdays 8am - 8pm {{ timezoneLabel }}</span>
        </div>
      </div>
    </template>
  </Toolbar>
</template>

<script>
import { getSydneyTimezoneLabel } from '@/services/getSydneyTimezoneLabel';
import Toolbar from 'primevue/toolbar';

export default {
  name: 'Header',
  components: {
    Toolbar,
  },
  data() {
    return {
      timezoneLabel: getSydneyTimezoneLabel(),
    };
  },
  methods: {
    goToLogin() {
      window.open('https://www.bridgit.com.au/');
    },
  },
  computed: {
    customLogo() {
      return process.env.VUE_APP_CUSTOM_THEME_LOGO;
    },
    phoneInfo() {
      return process.env.VUE_APP_CUSTOM_THEME_CONTACT ?? '1300 141 161';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';
.p-toolbar {
  background: $white-color;
  border: unset !important;
  padding: 0;
  padding: 0 1rem;
  height: 80px;
}

.padding-x {
  padding: 0 1.5rem;
}

.right-col {
  margin: 0 !important;
  padding: 0 !important;
}

.header-toolbar {
  padding-right: 1rem;
}

@media (max-width: 425px) {
  .custom-logo {
    width: 161px;
  }

  .header-toolbar {
    width: 133px;
    padding-right: 0;
  }
}

.phone-info {
  margin: 0px;
  font-size: 24px;
  color: $secondary-color;
  line-height: 27px;
  a {
    color: $secondary-color !important;
    cursor: pointer;
  }
}
.week-info {
  font-size: 11px;
  color: $secondary-color;
  position: absolute;
}
.custom-logo {
  height: 45px;
}
@media (max-width: 480px) {
  .phone-info a {
    cursor: pointer;
    color: $secondary-color !important;
    pointer-events: auto;
  }
  .phone-info {
    font-size: 14px;
  }
  .week-info {
    font-size: 9px;
    display: none;
  }
  .header-info {
    display: flex;
    align-items: center;
  }
}
</style>
